import { AxiosResponse } from "axios";
import { User, UserOptional } from "../../stores/user-store/types";
import Api from "../api";
import { AccessList, UserProps } from "../../pages/admin-panel/users/types";
import { ObjectId } from "../../types";
import { createFormData, getFileHeaders } from "../utils";
import { useGeneralStore, useUserStore } from "../../stores";

class UserApi extends Api {
  static getMe(): Promise<UserOptional> {
    return this.getData("/me");
  }

  static login(username: string, password: string): Promise<AxiosResponse> {
    return this.post("/login", { username, password });
  }

  static getUsers(): Promise<Array<UserProps>> {
    return this.getData("/user");
  }

  static deleteUser(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.deleteData(`/user/${id}`)
        .then(() => {
          useGeneralStore.getState().deleteUser(id);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static addUser(
    fullname: string,
    role: string,
    username: string,
    password: string,
    confirm_password: string,
    access_list: AccessList
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      this.postData<UserProps, {}>("/user", {
        fullname,
        role,
        username,
        password,
        confirm_password,
        access_list,
      })
        .then((user) => {
          useGeneralStore.getState().addUser(user);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static updateUser(
    id: ObjectId,
    fullname: string,
    role: string,
    username: string,
    password: string,
    confirm_password: string,
    access_list: AccessList,
    pic: File | null
  ): Promise<void> {
    const headers = getFileHeaders(pic);

    return new Promise((resolve, reject) => {
      this.patchData<UserProps, {}>(
        `/user/supervised-update/${id.$oid}`,
        createFormData({
          fullname,
          role,
          username,
          password,
          confirm_password,
          "access_list[]": access_list,
          pic,
        }),
        { headers }
      )
        .then((user) => {
          useGeneralStore.getState().editUser(user);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static updateSelf(fullname: string, file: File | null): Promise<void> {
    const headers = getFileHeaders(file);

    return new Promise((resolve, reject) => {
      this.patchData<User, {}>(
        "/user",
        createFormData({
          fullname,
          pic: file,
        }),
        { headers }
      )
        .then((user) => {
          useUserStore.getState().setUser(user);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}

export default UserApi;
